module.exports = __webpack_public_path__ + "static/media/mechanic_truck.abf25fd6.svg";